module.exports = __webpack_public_path__ + "static/media/pinkTheme-boy.63b16ae1.svg";